// DL-61835 (QA 2507004): mirrors the D2 -> legacy `_auth0org` param the iframe already appends
// (modules/iframe/utils/index.ts) for the reverse hop. Legacy's "Try Delogue 2.0" link now
// appends this same param (LoginApiController.GetBetaSiteURL) so D2 knows an org was already
// chosen on the legacy side instead of falling back to its own org picker.
export const LEGACY_ORG_HINT_PARAM = '_auth0org';

export const getLegacyOrgHint = (): string | null =>
  new URLSearchParams(window.location.search).get(LEGACY_ORG_HINT_PARAM);

// DL-64690: legacy's "Try Delogue 2.0" hands a superadmin an already-minted delegated token in the
// URL fragment (LoginApiController.GetBetaSiteURL). A fragment because it is never sent to a
// server, so the token cannot land in an access log or a Referer header. Read once, then stripped.
export const IMPERSONATION_TOKEN_KEY = '_imp';

export const takeImpersonationToken = (): string | null => {
  const hash = window.location.hash.replace(/^#/, '');
  if (!hash) return null;

  const token = new URLSearchParams(hash).get(IMPERSONATION_TOKEN_KEY);
  if (!token) return null;

  // Strip before anything else can read it, and without adding a history entry.
  window.history.replaceState(null, '', window.location.pathname + window.location.search);
  return token;
};
